import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import FeatureSwitch from '@/components/common/FeatureSwitch';

const EllipsisIcon = (props) => (
  <svg viewBox="0 0 512 512" {...props}>
    <path d="M304 256c0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48 48 21.5 48 48zm120-48c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm-336 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48z" />
  </svg>
);

const AdvancedOptionsComponent = ({
  menuRef,
  advancedActions,
  isMenuVisible,
  toggleMenu,
  selectOption,
  CurrentAction,
  components,
}) => (
  <div className="relative inline-block" ref={menuRef}>
    {advancedActions.length > 0 ? (
      <FeatureSwitch feature={Object.keys(components).map(key => components[key]?.feature)}>
        <button 
          type="button" 
          className="flex justify-center items-center w-9 h-4 p-0 bg-white border-0 hover:opacity-75 focus:outline-none" 
          onClick={toggleMenu}
        >
          <EllipsisIcon className="w-3/5 text-[#303030] fill-current" />
        </button>
      </FeatureSwitch>
    ) : null}
    {isMenuVisible ? (
      <ul className="list-none absolute right-0 mt-1 p-0 shadow-[0_0_5px_rgba(0,0,0,0.15)] rounded-md bg-white overflow-hidden z-[20]">
        {advancedActions.map(action => (
          <FeatureSwitch feature={components[action]?.feature} key={action}>
            <li className="max-w-[260px]">
              <button 
                type="button" 
                onClick={() => selectOption(action)}
                className="w-full p-3 border-0 bg-transparent text-[13px] text-left whitespace-nowrap hover:bg-[#fbfbfb] focus:outline-none transition-colors"
              >
                <FormattedMessage id={action} />
              </button>
            </li>
          </FeatureSwitch>
        ))}
      </ul>
    ) : null}
    <CurrentAction />
  </div>
);

AdvancedOptionsComponent.propTypes = {
  menuRef: PropTypes.object.isRequired,
  advancedActions: PropTypes.array.isRequired,
  isMenuVisible: PropTypes.bool.isRequired,
  toggleMenu: PropTypes.func.isRequired,
  selectOption: PropTypes.func.isRequired,
  CurrentAction: PropTypes.func.isRequired,
  components: PropTypes.object.isRequired,
};

export default AdvancedOptionsComponent;
